const constants = {
    PREMIUM_ANNUAL: 'PREMIUM_ANNUAL',
    PREMIUM_MONTHLY: 'PREMIUM_MONTHLY',
    PREMIUM_PRO_ANNUAL: 'PREMIUM_PRO_ANNUAL',
    PREMIUM_PRO_MONTHLY: 'PREMIUM_PRO_MONTHLY',
    FREE: 'always',
    ANNUAL: 'ANNUAL',
    EVERY_30_DAYS: 'EVERY_30_DAYS',
    MONTHLY: 'MONTHLY',
    DEV: "dev",
    BASIC: "basic",
    ADVANCED: "advanced",
    ENTERPRISE: "enterprise",
    RATES: "rates",
    RANGES: "ranges",
    ZIP_PREFIX: "zip_prefix",
    ZIP_RANGES: "zip_ranges",
    DEFAULT_PRICE: "default_price",
    FREE_SCHEDULED: "free_scheduled",
    FREE_PRODUCTS: "free_products",
    EXCEPTIONS: "exceptions",
    CSV: "csv",
    CHECKOUT_UI: "checkout_ui",
}

export default constants